import AudioCoverComponent from './index.js'

if (!window.AliPlayerComponent) {
  window.AliPlayerComponent = {}
}
window.AliPlayerComponent.AudioCoverComponent = AudioCoverComponent



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/AudioCoverComponent/export.js